import { render, staticRenderFns } from "./consult.vue?vue&type=template&id=67eb709b&"
import script from "./consult.vue?vue&type=script&lang=js&"
export * from "./consult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports